import React, { useCallback } from "react";

import CopyButton from "../button/CopyButton";
import { ThemeProvider } from "../ThemeContext";
import TextField from "./TextField";

interface CopyFieldProps extends React.ComponentProps<typeof TextField> {
  className?: string;
  value: string;
  buttonProps?: Partial<React.ComponentProps<typeof CopyButton>> &
    Record<string, unknown>;
}

const CopyField = ({
  className,
  label,
  value,
  buttonProps,
  ...props
}: CopyFieldProps) => {
  const onClickSelect = useCallback(
    (event: React.MouseEvent<HTMLInputElement>) => {
      event.currentTarget.select();
    },
    [],
  );

  return (
    <TextField
      className={className}
      label={label}
      value={value}
      readOnly={true}
      onClick={onClickSelect}
      style={{ textOverflow: "ellipsis" }}
      addon={
        <ThemeProvider theme="translucent">
          <CopyButton value={value} {...buttonProps} />
        </ThemeProvider>
      }
      {...props}
    />
  );
};

export default CopyField;
